import type { Router } from 'vue-router';
import { AppRoute } from '@/libs/routing';

/**
 * Leaves a settings screen the way it was entered. Without history (deep link,
 * bookmark, the old `/profile`) there is no tab bar to fall back on: a
 * sub-page goes up to the settings, the settings to the network's map.
 */
export function leaveSettings(router: Router, groupId: string | undefined) {
  if (router.options.history.state.back) router.back();
  else if (router.currentRoute.value.name !== AppRoute.SETTINGS) router.replace({ name: AppRoute.SETTINGS });
  else if (groupId) router.replace({ name: AppRoute.MAP, params: { groupId } });
  else router.replace({ name: AppRoute.SELECT_GROUP });
}
